import { skipToken } from "@reduxjs/toolkit/query";
import { accountIdSchema } from "@repo/app-types/entities/account";
import type { FC } from "react";
import { useCustomerDetailQuery } from "../../api/entities/customer.js";
import { renderCrumbLabel } from "../../app/navigation/crumbLabel.js";
import { PH_MASK_CLASS } from "../analytics/sessionRecordingMasking.js";

interface CustomerNameCrumbLabelProps {
  accountId: string | undefined;
}

/** Breadcrumb label for the customer detail page. */
export const CustomerNameCrumbLabel: FC<CustomerNameCrumbLabelProps> = (
  props,
) => {
  const { accountId } = props;
  const parsedId = accountIdSchema.safeParse(accountId);
  const result = useCustomerDetailQuery(
    parsedId.success ? parsedId.data : skipToken,
  );
  return (
    <span className={PH_MASK_CLASS}>
      {renderCrumbLabel({
        hasValidId: parsedId.success,
        result: { data: result.currentData, isError: result.isError },
        buildText: (detail) => detail.name,
        fallbackText: "Customer",
      })}
    </span>
  );
};
